import { Map } from 'immutable'
import * as actionTypes from './actionTypes'

const initialState = Map({
    list: Map({
        year: null,
        data: null,
        fetching: false,
        error: null,
    }),
    scoring: Map({
        data: {},
        fetching: false,
        saving: false,
        error: null,
    }),
})

function reportCarrierScoring(state = initialState, action) {
    switch (action.type) {
        // Fetch
        case actionTypes.FETCH:
            return state.setIn(['list', 'year'], action.payload).setIn(['list', 'fetching'], true)
        case actionTypes.FETCH_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['list', 'fetching'], false).setIn(['list', 'data'], action.payload)
            })
        case actionTypes.FETCH_REJECTED:
            return state.withMutations(map => {
                map.setIn(['list', 'fetching'], false).setIn(['list', 'error'], action.payload)
            })
        case actionTypes.FETCH_CANCELLED:
            return state.setIn(['list', 'fetching'], false)

        // Clear
        case actionTypes.CLEAR:
            return state.setIn(['list', 'data'], null)

        // Fetch scoring

        case actionTypes.FETCH_SCORING_STARTED:
            return state.setIn(['scoring', 'fetching'], true)
        case actionTypes.FETCH_SCORING_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['scoring', 'data'], action.payload)
                    .setIn(['scoring', 'fetching'], false)
                    .setIn(['scoring', 'error'], null)
            })
        case actionTypes.FETCH_SCORING_REJECTED:
            return state.withMutations(map => {
                map.setIn(['scoring', 'fetching'], false).setIn(['scoring', 'error'], action.payload)
            })
        case actionTypes.FETCH_SCORING_CANCELLED:
            return state.setIn(['scoring', 'fetching'], false)

        // Save question

        case actionTypes.SAVE_SCORING_STARTED:
            return state.withMutations(map => {
                map.setIn(['scoring', 'saving'], true).setIn(['scoring', 'error'], null)
            })
        case actionTypes.SAVE_SCORING_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['scoring', 'saving'], false).setIn(['list', 'data'], action.payload)
            })
        case actionTypes.SAVE_SCORING_REJECTED:
            return state.withMutations(map => {
                map.setIn(['scoring', 'saving'], false).setIn(['scoring', 'error'], action.payload)
            })
        case actionTypes.SAVE_SCORING_CANCELLED:
            return state.setIn(['scoring', 'saving'], false)

        default:
            return state
    }
}

export default reportCarrierScoring
